import { createAxiosInstance } from "./api";
import initializeConfig from "./api.config";
import { interceptorAfterResponse } from "./api.interceptors";

const RequestToken = async () => {
  const { apiConfig, apimSubsKey } = await initializeConfig();
  const apiInstance = createAxiosInstance(apiConfig);

  interceptorAfterResponse(apiInstance);

  return {
    get: async (url: string, queryParams: any = {}) => {
      const getParams = { params: queryParams, headers: { "Ocp-Apim-Subscription-Key": apimSubsKey } };
      return apiInstance.get(url, getParams);
    },
  };
};

export default RequestToken();
